<!-- Compiled at 2026-10-07T06:21:14.844Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<ng-container
					*lowgileForm="'form110'; preventNavigation: true; let $formDirective; let form = form"
				>
					<ng-container *ngIf="screen.gs && screen.columnVisibility"
						><div
							class="layout-block vertical"
							[style.align-items]="'inherit'"
							[style.gap]="'1em'"
						>
							<ng-container
								*ngIf="(screen.gs.status.employeeShouldAct && screen.viewMode.isEmployee) || (screen.gs.status.managerShouldAct && screen.viewMode.isManager)"
								><span
									style="font-weight: bold; font-size: 130%"
									[innerHtml]="`Please ${screen.gs.status.nextAction} ${screen.gs.nextActionDeadlineStr ? `at the latest until ${screen.gs.nextActionDeadlineStr}.` : ''}` | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span
							></ng-container>

							<ng-container
								*ngIf="screen.gs.status.employeeShouldAct && screen.viewMode.isManager"
								><span
									style="font-weight: bold; font-size: 130%"
									[innerHtml]="`Please wait for the employee to ${screen.gs.status.nextAction} ${screen.gs.nextActionDeadlineStr ? `at the latest until ${screen.gs.nextActionDeadlineStr}.` : ''}` | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span
							></ng-container>

							<ng-container
								*ngIf="screen.gs.status.managerShouldAct && screen.viewMode.isEmployee"
								><span
									style="font-weight: bold; font-size: 130%"
									[innerHtml]="`Please wait for your manager to ${screen.gs.status.nextAction}  ${screen.gs.nextActionDeadlineStr ? `at the latest until ${screen.gs.nextActionDeadlineStr}.` : ''}` | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span
							></ng-container>

							<ng-container *ngIf="!screen.gs.nextAction"
								><ng-container *ngIf="!screen.gs.status.isClosed; else else123"
									><span
										style="font-weight: bold; font-size: 130%"
										[innerHtml]="'There is currently no need for action. We will inform you when the next step becomes available' | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span
								></ng-container>
								<ng-template #else123>
									<span
										style="font-weight: bold; font-size: 130%"
										[innerHtml]="'This personal development process is closed, there is no more need for action' | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span> </ng-template
							></ng-container>

							<ng-container
								*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!((screen.gs.status.employeeShouldAct && !screen.viewMode.isEmployee) || (screen.gs.status.managerShouldAct && !screen.viewMode.isManager))) as $disabled"
							>
								<Toolbox-GoalSettingInclude
									[$formDirective]="$formDirective"
									[$disabled]="$disabled"
									[$ignoreValidations]="$ignoreValidations"
									[gs]="screen.gs"
									[viewMode]="screen.viewMode"
									[columnVisibility]="screen.columnVisibility"
								>
								</Toolbox-GoalSettingInclude>
							</ng-container>
							<ng-container *ngIf="screen.viewMode.isEmployee"
								><ng-container *ngIf="screen.gs.status.employeeCanEdit"
									><div
										class="layout-block"
										[style.align-items]="'inherit'"
										[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
										[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
										[style.gap]="'1em'"
									>
										<ng-container
											*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(form.invalid)) as $disabled"
										>
											<button
												mat-raised-button
												class="has-click-handler"
												color="primary"
												(click)="handler_ButtonBlock_83_click_$adhoc_0($event, { form, $disabled: $disabled })"
												[disabled]="$disabled"
											>
												<mat-icon>{{'send'}}</mat-icon
												><span
													[innerHtml]="'Complete goal setting and submit to manager' | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span>
											</button>
										</ng-container>
										<button
											mat-raised-button
											class="has-click-handler"
											color="basic"
											(click)="handler_ButtonBlock_84_click_$adhoc_0($event, { form, $disabled: $disabled })"
											[disabled]="$disabled"
										>
											<mat-icon>{{'save'}}</mat-icon
											><span
												[innerHtml]="'Save as draft' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</button></div
								></ng-container>

								<ng-container *ngIf="screen.gs.status.isSelfReviewPending"
									><div
										class="layout-block"
										[style.align-items]="'inherit'"
										[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
										[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
										[style.gap]="'1em'"
									>
										<ng-container
											*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(form.invalid)) as $disabled"
										>
											<button
												mat-raised-button
												class="has-click-handler"
												color="primary"
												(click)="handler_ButtonBlock_118_click_$adhoc_0($event, { form, $disabled: $disabled })"
												[disabled]="$disabled"
											>
												<mat-icon>{{'send'}}</mat-icon
												><span
													[innerHtml]="'Complete self-review and submit to manager' | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span>
											</button>
										</ng-container>
										<button
											mat-raised-button
											class="has-click-handler"
											color="basic"
											(click)="handler_ButtonBlock_119_click_$adhoc_0($event, { form, $disabled: $disabled })"
											[disabled]="$disabled"
										>
											<mat-icon>{{'save'}}</mat-icon
											><span
												[innerHtml]="'Save as draft' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</button></div
								></ng-container>

								<ng-container *ngIf="screen.gs.status.isManagerReviewDone"
									><div
										class="layout-block"
										[style.align-items]="'inherit'"
										[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
										[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
										[style.gap]="'1em'"
									>
										<button
											mat-raised-button
											class="has-click-handler"
											color="primary"
											(click)="handler_ButtonBlock_99_click_$adhoc_0($event, { form, $disabled: $disabled })"
											[disabled]="$disabled"
										>
											<mat-icon>{{'send'}}</mat-icon
											><span
												[innerHtml]="'Acknowledge manager\'s assessment and go to next period\'s goal setting' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</button></div
								></ng-container>
							</ng-container>

							<ng-container *ngIf="screen.viewMode.isManager"
								><ng-container *ngIf="screen.gs.status.isGoalsSubmitted"
									>@let isSomeRejectionComment =
									_ScopeBlock_var_isSomeRejectionComment_108({ app, screen,
									$pathSegments, $disabled, form });
									<ng-container
										*lowgileScope="isSomeRejectionComment; as: 'isSomeRejectionComment'; let $scope"
									>
										<div
											class="layout-block"
											[style.align-items]="'inherit'"
											[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
											[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
											[style.gap]="'1em'"
										>
											<ng-container
												*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(isSomeRejectionComment)) as $disabled"
											>
												<button
													mat-raised-button
													class="has-click-handler"
													color="primary"
													(click)="handler_ButtonBlock_94_click_$adhoc_0($event, { form, isSomeRejectionComment, $disabled: $disabled })"
													[disabled]="$disabled"
												>
													<mat-icon>{{'thumb_up'}}</mat-icon
													><span
														[innerHtml]="'Approve goal setting' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</button>
											</ng-container>
											<ng-container
												*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(!isSomeRejectionComment)) as $disabled"
											>
												<button
													mat-raised-button
													class="has-click-handler"
													color="primary"
													(click)="handler_ButtonBlock_102_click_$adhoc_0($event, { form, isSomeRejectionComment, $disabled: $disabled })"
													[disabled]="$disabled"
												>
													<mat-icon>{{'thumb_down'}}</mat-icon
													><span
														[innerHtml]="'Reject goal setting with comments' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</button>
											</ng-container>
										</div> </ng-container
								></ng-container>

								<ng-container *ngIf="screen.gs.status.isSelfReviewDone"
									><div
										class="layout-block"
										[style.align-items]="'inherit'"
										[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
										[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
										[style.gap]="'1em'"
									>
										<ng-container
											*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(form.invalid)) as $disabled"
										>
											<button
												mat-raised-button
												class="has-click-handler"
												color="primary"
												(click)="handler_ButtonBlock_106_click_$adhoc_0($event, { form, $disabled: $disabled })"
												[disabled]="$disabled"
											>
												<mat-icon>{{'send'}}</mat-icon
												><span
													[innerHtml]="'Complete assessment and make visible for employee' | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span>
											</button>
										</ng-container>
										<button
											mat-raised-button
											class="has-click-handler"
											color="basic"
											(click)="handler_ButtonBlock_107_click_$adhoc_0($event, { form, $disabled: $disabled })"
											[disabled]="$disabled"
										>
											<mat-icon>{{'save'}}</mat-icon
											><span
												[innerHtml]="'Save as draft' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</button></div
								></ng-container>
							</ng-container></div
					></ng-container>
				</ng-container>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
